var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute top-0 left-0 px-4 py-1"},[_c('Button',{attrs:{"color":"btn-transparent-primary","size":"small","label":_vm.$t('back')},on:{"click":_vm.goBack},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('LeftArrowSVG',{staticClass:"w-6 mr-2"})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }